import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {
  ref,
  onMounted,
} from 'vue';
import {
  MainDesktop,
  MainMobile,
} from '@views';
import { pushPage } from '@utils/route.helper';
import { errorType } from '@interface/error';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const isDesktop = ref(window.innerWidth >= 769);

// 창 크기가 변할 때마다 체크
window.addEventListener('resize', () => {
  isDesktop.value = window.innerWidth >= 769;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (isDesktop.value)
      ? (_openBlock(), _createBlock(_unref(MainDesktop), {
          key: 0,
          class: "desktop"
        }))
      : (_openBlock(), _createBlock(_unref(MainMobile), {
          key: 1,
          class: "mobile"
        }))
  ]))
}
}

})